<template>
  <CHeader id="nav" with-subheader>
    <!-- <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand
      class="mx-auto d-lg-none"
      src="img/brand/coreui-vue-pro-logo.svg"
      width="190"
      height="46"
      alt="CoreUI Logo"
    /> -->
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <div id="image-card" class="col-md-6">
          <div class="align-items-center" v-if="$store.getters.get_company">
            <img class="banner-image" width="200" src="../../public/Crinverlogo.png" alt="">
          </div>
        </div>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink>
          Bienvenido, <b>{{ fullName }}</b>
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink>
          Empresa:<b>&nbsp;{{ $store.getters.get_company ? $store.getters.get_company.name : "" }}</b> 
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3" v-if="$store.getters.get_campu != null">
        <CHeaderNavLink>
          Sede: <b>&nbsp;{{ $store.getters.get_campu.name }}</b> 
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3" v-if="$store.getters.get_rol != null">
        <CHeaderNavLink>
          Rol: <b>&nbsp;{{ $store.getters.get_rol.name }}</b> 
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav>
      <CHeaderNavItem class="px-3">
        <button
          @click="() => $store.commit('toggle', 'darkMode')"
          class="c-header-nav-btn"
        >
          <CIcon v-if="$store.state.darkMode" name="cil-sun"/>
          <CIcon v-else name="cil-moon"/>
        </button>
      </CHeaderNavItem>
      <TheHeaderDropdownHrAlerts/>
      <TheHeaderDropdownNotif/>
      <TheHeaderDropdownAccnt class="pr-3"/>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import TheHeaderDropdownNotif from './TheHeaderDropdownNotif'
import TheHeaderDropdownHrAlerts from './TheHeaderDropdownHrAlerts'
import TheHeaderDropdownTasks from './TheHeaderDropdownTasks'
import TheHeaderDropdownMssgs from './TheHeaderDropdownMssgs'
import { mapActions } from "vuex";

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt,
    TheHeaderDropdownNotif,
    TheHeaderDropdownHrAlerts,
    TheHeaderDropdownTasks,
    TheHeaderDropdownMssgs
  },
  data() {
    return {
      logo: ""
    }
  },
  computed: {
    company() {
      return this.$store.getters.get_company;
    },
    fullName() {
      const user = this.$store.getters.get_all_user;
      if (!user) return 'Usuario';
      
      const firstName = user.name || user.first_name || user.nombre || '';
      const lastName = user.last_name || user.lastname || user.apellido || user.apellidos || '';
      
      const fullName = `${firstName} ${lastName}`.trim();
      return fullName || 'Usuario';
    }
  },
  created() {
    // Safe access to logo
    const company = this.$store.getters.get_company;
    this.logo = (this.$store.getters.get_all_user.id == 1 || !company || Array.isArray(company)) ? null : company.logo;
    
    // Si no hay empresa cargada (o es un array vacío) y tenemos el ID en el usuario, la buscamos
    if ((!company || (Array.isArray(company) && company.length == 0)) && this.$store.getters.get_all_user.company_id) {
       this.get({
          url: this.$store.getters.get__url + "/companies/" + this.$store.getters.get_all_user.company_id + "/show",
          token: this.$store.getters.get__token,
        })
          .then((response) => {
            this.$store.commit("mt_set_company", response);
            // Actualizar logo después de cargar
            this.logo = this.$store.getters.get_all_user.id == 1 ? null : response.logo;
          })
          .catch((error) => {
            console.error("Error al obtener la empresa en Header:", error);
          });
    }
  },
  methods: {
    ...mapActions(["get"]),
  },
}
</script>

<style scoped>
.banner-image {
  width: 90px;
  height: auto;
  max-height: 100%;
  object-fit: cover;
}

#image-card {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>